import * as React from "react";
import { SVGProps } from "react";
export const NavigationIcon = (props: SVGProps<SVGSVGElement>) => (
    <svg
        width="1em"
        height="1em"
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
    >
        <path
            d="M8.333 11.667L3.083 9.54198C2.90233 9.47265 2.76 9.36131 2.656 9.20798C2.552 9.05531 2.5 8.88198 2.5 8.68798C2.5 8.49331 2.552 8.32298 2.656 8.17698C2.76 8.03098 2.90233 7.92331 3.083 7.85398L15.708 3.16698C15.8887 3.09698 16.059 3.08631 16.219 3.13498C16.3783 3.18365 16.5137 3.26365 16.625 3.37498C16.7363 3.48631 16.8163 3.62165 16.865 3.78098C16.9137 3.94098 16.903 4.11131 16.833 4.29198L12.146 16.938C12.0627 17.132 11.9447 17.2743 11.792 17.365C11.6387 17.455 11.4787 17.5 11.312 17.5C11.1453 17.5 10.9857 17.4513 10.833 17.354C10.6803 17.2566 10.5623 17.118 10.479 16.938L8.333 11.667ZM11.271 14.271L14.521 5.47898L5.729 8.72898L9.688 10.312L11.271 14.271Z"
            fill="currentColor"
        />
    </svg>
);
NavigationIcon.displayName = "NavigationIcon";
